import { AlertBanner } from '@resurs-internal/mui';
import { useSearchParams } from 'react-router-dom';

import useTranslation from '../../hooks/useTranslation';
import { PARAM_ERROR } from '../AuthenticationWrapper';

const AuthenticationErrorMessage = () => {
    const [params] = useSearchParams();
    const translate = useTranslation();

    // Derived straight from the URL — the previous useState/useEffect only
    // mirrored this value into state one render later.
    const message = params.get(PARAM_ERROR);

    return (
        message && (
            <AlertBanner
                severity="error"
                title={translate('login.failed.title')}
                subtitle={translate('login.failed.description')}
                sx={{ my: 2 }}
            />
        )
    );
};

export default AuthenticationErrorMessage;
